<template>
  <section class="section">
    <div class="columns is-centered">
      <div class="column">
        <h3 class="title is-4 is-spaced">
          <span>{{ $t('orders.title') }}</span>
        </h3>
        <!-- <div class="field">
          <label class="label">{{ $t('orders.fields.orderNumber') }}</label>
          <p class="control has-icons-left has-icons-right">
            <input class="input" type="text" :placeholder="$t('app.texts.search')" />
            <span class="icon is-small is-left">
              <i class="fa fa-search"></i>
            </span>
          </p>
        </div>
        <div class="field">
          <label class="label">{{ $t('orders.fields.date') }}</label>
          <p class="control has-icons-left has-icons-right">
            <input class="input" type="date" />
            <span class="icon is-small is-left">
              <i class="fa fa-calendar"></i>
            </span>
          </p>
        </div> -->
        <div class="field">
          <table class="table is-fullwidth">
            <thead>
              <tr>
                <th>{{ $t('orders.fields.orderNumber') }}</th>
                <th>{{ $t('orders.fields.date') }}</th>
                <th>{{ $t('orders.fields.status') }}</th>
                <th>{{ $t('orders.fields.actions') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="order in paginatedOrders" :key="order.id">
                <td>{{ order.id }}</td>
                <td> {{ order.createdAt }} </td>
                <td><status-tag :status="order.status.status.toLowerCase()"></status-tag></td>
                <td>
                  <router-link
                    :to="{
                      name: 'OrderDetails',
                      params: {
                        id: order.id,
                      },
                    }"
                    class="nav-link"
                  >
                    <button class="button is-success is-fullwidth">{{ $t('orders.buttons.view') }}</button>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination :currentPage="currentPage" :totalItems="orders.length" :pageSize="pageSize" @page-change="onPageChange"/>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import StatusTag from '../../components/forms/StatusTag.vue'
import { Helpers } from '@/services/helpers.service'
import { FooshiApi } from '@/services/fooshiApi.service'
import Pagination from '../../components/Pagination.vue'

export default {
  components: {
    StatusTag,
    Pagination
  },
  name: 'Orders',
  methods: {
    async fetchOrders () {
      var response = await FooshiApi.getAllOrders()
      if (response.status) {
        this.orders = response.data
      }
    },
    onPageChange (newPage) {
      this.currentPage = newPage
    }
  },
  async mounted () {
    await this.fetchOrders()
    this.ready = true
  },
  computed: {
    formattedOrders: function () {
      return this.orders.map(order => {
        order.createdAt = Helpers.dateFormat(order.createdAt)
        return order
      })
    },
    paginatedOrders () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.formattedOrders.slice(start, end)
    }
  },
  data () {
    return {
      orders: [],
      currentPage: 1,
      pageSize: 10
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/orders/Orders.vue